import takeBowl from "model/actions/city/takeBowl";
import { randomMessage } from "model/message";

// Both variants have to read as the same narrator: the street, the bowl, the drinking, the
// ground. No line names the state it is describing — the collapse is shown and not said.
const description = () =>
  randomMessage([
    [
      "the street tilts. the legs go.",
      "a dog's bowl at the foot of a trough.",
      "drink on hands and knees.",
      "the ground comes up.",
    ],
    [
      "in past the first houses and no further.",
      "a dog's bowl in the dirt. water in it and dust on the water.",
      "drink it all and do not look up.",
      "dark comes in at the edges.",
    ],
  ]);

const enter = (onDone) => ({
  title: "the town",
  description: description(),
  buttons: [takeBowl(onDone)],
});

export default enter;
